import { createContext, useContext } from 'react';

/**
 * Point d'accès au panneau de discussion depuis n'importe où dans un dossier.
 *
 * C'est ce contexte qui rend l'ancrage possible : la ligne d'une victime, tout en bas
 * d'un onglet, doit pouvoir ouvrir le fil sur cette victime précise sans connaître le
 * panneau ni remonter une dizaine de props à travers des composants qui n'ont rien à
 * voir avec la conversation.
 *
 * `compteursAncres` alimente les pastilles posées sur ces mêmes lignes : « il y a déjà
 * deux remarques sur cette victime » est ce qui donne envie de cliquer, et un dossier
 * sans pastille reste silencieux comme avant.
 */
export const ContexteDiscussion = createContext(null);

/**
 * Hors d'un dossier - ou quand l'agent n'a pas l'habilitation de lecture - le contexte
 * est absent. On rend alors un objet inerte plutôt que `null` : les composants d'ancrage
 * sont disséminés dans des onglets réutilisés ailleurs, et leur imposer un test à chaque
 * usage garantit qu'on l'oubliera quelque part.
 */
const INERTE = {
  disponible: false,
  ouvrir: () => { },
  ouvrirSur: () => { },
  compteursAncres: {},
};

export const useDiscussion = () => useContext(ContexteDiscussion) || INERTE;
